<template>
    <van-button
        block
        plain
        type="default"
        native-type="button"
        @click="onClick"
        class="tw-rounded-lg tw-py-5 tw-my-3"
    >
        <template #icon>
            <img
                :src="require('../../../assets/landing/img/google.png')"
                alt=""
                class="tw-w-[16px] tw-h-[16px]"
            />
        </template>
        Continue with Google
    </van-button>
</template>

<script>
export default {
    data() {
        return {
            clientId: `${process.env.MIX_GOOGLE_CLIENT_ID}`,
            scope: "profile email",
            responseType: "token",
            redirectUri: `${process.env.MIX_GOOGLE_REDIRECT_URI}`,
        };
    },
    mounted() {},
    methods: {
        onClick() {
            window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&response_type=${this.responseType}&scope=${this.scope}`;
        },
    },
};
</script>
